import React from 'react';
import { Box, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Theme from 'theme';

function DemoModeBanner() {
  return (
    <Box sx={{
      backgroundColor: Theme.custom.colors.lightInfoMain,
      display: 'flex',
      alignItems: 'center',
      height: Theme.custom.demoBarHeight,
      px: 2,
    }}
    >
      <InfoOutlinedIcon sx={{ mr: 1 }} fontSize='small' />
      <Typography variant='body1' display='flex' alignItems='center'>
        You’re in
        <Typography variant='body1' fontWeight={700} ml={0.5}>
          Demo Mode
        </Typography>
        . Some functionality is limited,
        and all data is for demonstration purposes only — not real patients.
      </Typography>
    </Box>
  );
}

export default DemoModeBanner;
